<template>
  <div>
    <el-table :data="tableData" height="calc(100% - 50px)" border stripe v-loading="loading">
      <el-table-column width="100" type="index" label="序号/场次"></el-table-column>
      <el-table-column prop="userName" label="培训人"></el-table-column>
      <el-table-column prop="orgUnitName" label="所属单位"></el-table-column>
      <el-table-column prop="name" label="课程名称"></el-table-column>
      <el-table-column prop="trainingTypeName" label="培训类型"></el-table-column>
      <el-table-column prop="singleChoiceQuantity" label="关联考试计划"></el-table-column>
      <el-table-column prop="coursewareTimes" label="课件包含学时(h)">
        <template slot-scope="scope">
          <span>{{ scope.row.coursewareTimes | showText('second') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coursewareCredits" label="课件包含学分"></el-table-column>
      <el-table-column prop="statusName" label="培训状态"></el-table-column>
      <el-table-column prop="studyTimeEnd" label="通过时间">
        <template slot-scope="scope">
          <span>{{ scope.row.studyTimeEnd | showText('time') }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px text-right"
      background
      :current-page.sync="page.pageNo"
      @size-change="searchList"
      @current-change="findList"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :page-size.sync="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import { TrainingRecordApi } from '@wiz-api/training-management'
import dayjs from 'dayjs'

const trainingRecordApi = new TrainingRecordApi()
export default {
  name: 'personTrainingRecord',
  props: {
    userId: {
      type: String,
      default: '',
    },
  },
  methods: {
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      if (!this.userId) return
      this.loading = true
      const [err, res] = await trainingRecordApi.getList({
        userId: this.userId,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      this.loading = false
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
    },
    formatSeconds(s) {
      let hours = Math.floor(s / 3600)
      hours = hours < 10 ? `0${hours}` : hours
      let minutes = Math.floor((s % 3600) / 60)
      minutes = minutes < 10 ? `0${minutes}` : minutes
      let seconds = s % 60
      seconds = seconds < 10 ? `0${seconds}` : seconds
      return `${hours}:${minutes}:${seconds}`
    },
  },
  data() {
    return {
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
      },
      total: 0,
      loading: false,
    }
  },
  filters: {
    showText: (val, type) => {
      let result = val
      if (type === 'time' && val) {
        result = dayjs(val).format('YYYY-MM-DD HH:mm:ss')
      }
      if (type === 'second' && val) {
        result = this.formatSeconds(val)
      }
      return result
    },
  },
  async created() {
    this.findList()
  },
}
</script>

<style></style>
